export default __webpack_public_path__ + "static/media/CardPurple.7919feb8.svg";